import { Box, Container, Typography } from "@mui/material";

export const ContactFooter = ({ href, icon, alt, iconHeight = 45 }) => {
  return (
    <Box
      component="footer"
      sx={{
        position: 'sticky',
        top: '100vh',
        py: 2,
        mb: 0.5,
        borderTop: 1,
        borderColor: 'divider',
        backgroundColor: 'background.paper',
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 1, flexGrow: 0, flexShrink: 0 }}>
          <Typography variant="body3" color="text.secondary">
            Связаться с нами:
          </Typography>
          <Box
            component="a"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'flex',
              alignItems: 'center',
              transition: 'transform 0.2s ease-in-out',
              '&:hover': {
                transform: 'scale(1.1)',
              },
              '&:active': {
                transform: 'scale(0.95)',
              }
            }}
          >
            <Box
              component="img"
              src={icon}
              alt={alt}
              sx={{ height: iconHeight }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};